import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'default-passive-events'
import router from "@/router/router";
import qs from 'qs'

import 'element-ui/lib/theme-chalk/index.css';
import * as echarts from 'echarts'

import axios from 'axios';

// 引入Vue-i18n
import VueI18n from 'vue-i18n'
import cn from '../src/assets/lang/cn.js'
import en from '../src/assets/lang/en.js'

// 以插件的形式
Vue.use(VueI18n)
//创建VueI18n实例
const i18n = new VueI18n({
  locale: localStorage.getItem('language') || 'cn', //语言标识
  messages: {
    'cn': cn,
    'en': en
  },
  silentTranslationWarn: true, // 去除国际化警告
})

//使用axios
Vue.prototype.axios = axios;
Vue.prototype.axios.defaults.withCredentials=true;

//使用ElementUI框架
Vue.use(ElementUI);

//使用store
Vue.config.productionTip = false;

// 使用echarts
Vue.prototype.$echarts = echarts

//使用qs
Vue.prototype.$qs = qs;

router.beforeEach((to, from, next) => {
  // 1.如果访问的是登录页面（无需权限），直接放行
  if (to.path === '/login' || to.path === '/register') return next()
  // 2.如果访问的是有登录权限的页面，先要获取token
  const tokenStr = window.sessionStorage.getItem('token')
  // 2.1如果token为空，强制跳转到登录页面；否则，直接放行
  if (!tokenStr) {
    alert("请登录")
    return next('/login')
  }
  next()
})

new Vue({
  el: '#app',
  i18n,
  render: h => h(App),
  router
});
Vue.config.productionTip = false

